import { RootState } from '@/store';
import {PayloadAction, createSlice} from '@reduxjs/toolkit';

type IAddress = {
  addressUpdated: boolean;
  address: {
    district: string;
    state: string;
    locality: string;
    country: string;
    postalCode: string;
    line1?: string;
    tehsil?: string;
    landmark?: string;
  };
  coordinates: {
    latitude: number;
    longitude: number;
  };
};

const initialState: IAddress = {
  addressUpdated: false,
  address: {
    locality: '',
    district: '',
    state: '',
    country: '',
    postalCode: '',
  },
  coordinates: {
    latitude: 28.6448,
    longitude: 77.216721,
  },
};

export const AddStoreSlice = createSlice({
  name: 'addStore',
  initialState,
  reducers: {
    updatedAddress: (state, {payload}: PayloadAction<Partial<IAddress>>) => {
      if (payload.addressUpdated != undefined) {
        state.addressUpdated = payload.addressUpdated;
      }
      if (payload.address) {
        state.address = payload.address;
      }
      if (payload.coordinates) {
        state.coordinates = payload.coordinates;
      }
    },
  },
});

export const {
  updatedAddress,
  // resetAddressUpdated,
} = AddStoreSlice.actions;
export default AddStoreSlice.reducer;

export const AddStoreSelector = (state: RootState) => state.store;
export const AddStoreCoordinates = (state: RootState) =>
  state.store.coordinates;
export const AddStoreAddress = (state: RootState) => state.store.address;
